import './App.scss';

import { useCallback, useContext, useEffect, useState } from 'react';

import { LoginModal } from './components/Modals/LoginModal/LoginModal';
import { MvAgentCart } from './components/MvAgentCart/MvAgentCart';
import { MvAgentFavourites } from './components/MvAgentFavourites/MvAgentFavourites';
import { useSession } from './hooks/useSession';
import { setupSession } from './network/axios';
import { TranslationsContext, TranslationsState } from './providers/TranslationsProvider';
import { useLogin } from './hooks/useLogin';

declare global {
  interface Window {
    ikea: Record<Exclude<string, 'mvAgent'>, any> & {
      mvAgent: Record<Exclude<string, 'isUserLoggedIn'>, any> & {
        isUserLoggedIn: () => Promise<boolean>;
      };
    };
    sendEvent?: any;
  }
}

const App = () => {
  const { translationsState, getTranslations } = useContext(TranslationsContext);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const closeModal = useCallback(() => setIsLoginModalOpen(false), []);
  const loginInfo = useLogin(isLoginModalOpen, closeModal);
  useSession();

  useEffect(() => {
    getTranslations();
  }, [getTranslations]);

  useEffect(() => {
    window.ikea.mvAgent = window.ikea.mvAgent || {};
    window.ikea.mvAgent.isUserLoggedIn = async () => (await setupSession()).isLoggedIn;
  }, []);

  return (
    <>
      {translationsState === TranslationsState.DONE && (
        <>
          <MvAgentCart />
          <MvAgentFavourites />
          <LoginModal loginInfo={loginInfo} open={isLoginModalOpen} setOpen={setIsLoginModalOpen} />
        </>
      )}
    </>
  );
};

export default App;
